import React, { forwardRef, useImperativeHandle } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';

export const NoteTextArea = ({ input }) => {
  return <textarea {...input} className="form-control" rows="10" />;
};

const NoteForm = forwardRef(function NoteForm({ onSubmit, initialValues }, ref) {
  const methods = useForm({ defaultValues: initialValues || {} });
  const { handleSubmit, control } = methods;

  useImperativeHandle(ref, () => ({ submit: () => handleSubmit(onSubmit)() }));

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label htmlFor="note">Note</label>
          <Controller
            name="text"
            control={control}
            render={({ field }) => <NoteTextArea input={field} />}
          />
        </div>
      </form>
    </FormProvider>
  );
});

export default NoteForm;
